<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="container">
      <ruejai-club-banner-editor
        v-model="form"
        :image-url="imageUrl"
        class="mt-4"
      ></ruejai-club-banner-editor>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import { uploadImage, getPublicImageUrl } from "@/god"
import RuejaiClubBannerEditor from "../components/RuejaiClubBannerEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    RuejaiClubBannerEditor,
  },
  data() {
    const title = "สร้าง Ruejai Club Banner"
    const imageUrl = ""
    const form = {
      imageFile: null,
      title: "",
      ruejaiClubPackageId: null,
    }

    return {
      title,
      form,
      imageUrl,
    }
  },
  methods: {
    async handleClickSave() {
      try {
        await this.createBanner()
        this.$router.push({ name: "RuejaiClubBannerListPage" })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        this.$message.error("ไม่สามารถสร้าง Ruejai Club Banner ได้")
      }
    },
    async createBanner() {
      const { title, imageFile, ruejaiClubPackageId } = this.form

      const imageUrl = await this.uploadPublicImage(imageFile)

      const params = {
        title,
        image_url: imageUrl,
        ruejai_club_package_id: ruejaiClubPackageId,
      }

      await baanRueJaiClient.admin.ruejaiClub.banners.post(params)
    },
    async uploadPublicImage(file) {
      const image = await uploadImage(file, file.name, "article")
      const { url } = await getPublicImageUrl(image)

      return url
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>
